<template>
  <a v-if="show" :href="link" id="upgrade-button" class="btn btn-lg" data-testid="upgrade-button">
    Upgrade
  </a>
</template>

<script>
import featureKey from '../../feature_key.macro';
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(["features", "currentOrganization"]),
    link: function() {
      const page = this.$route.path.includes("dashboard") ? "dashboard" : "viewer";
      return `/plans?utm_campaign=upgrade&utm_medium=button&utm_source=${page}`;
    },
    show: function() {
      return this.features?.[featureKey("upgrade-button-dashboard-viewer")] && this.currentOrganization.attributes.free;
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/packs/colors.scss";
a#upgrade-button.btn {
  font-family: SFPro;
  background-image: linear-gradient(113deg, #f09819 12%, #ff5858 96%);
  text-decoration: none;
  color: $white;
  font-size: .75rem;
  border-radius: 4px;
  border-top: linear-gradient(113deg, #f09819 12%, #ff5858 96%);
  border-bottom: linear-gradient(113deg, #f09819 12%, #ff5858 96%);
  border-left: none;
  border-right: none;
  padding: .4rem .8rem;
  margin-right: 1.5rem;
}

a:hover {
  text-decoration: none;
  color: $white;
}
</style>
